import React from 'react';
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import PaymentForm2 from "../PaymentFormUpgrade";
import { usePaymentContext } from '@webapps/reactjs-tech-components';

const { NX_STRIPE_KEY } = process.env;

// Load Stripe script
// const stripePromise = loadStripe("pk_test_51NtUK8DvOOETgTixlTAdeJbWLlyQqEcpr5KbpGR3tY3ZK2Tk8ewVcQMssOTqvR5AtGZ3gczdiqNLFMFCragylwbK00SSkQN7SI");
const stripePromise = loadStripe(NX_STRIPE_KEY);


// This component represents Stripe Container with Payment Form
export default function StripeContainer2() {

  const { paymentAmount } = usePaymentContext();
  const totalAmount = paymentAmount;

  // Define Payment options
  const options = {
    mode: 'payment',
    currency: 'eur',
    // Define payment amount
    amount: totalAmount*100,
    // Define stripe appearance here (see Stripe Appearance API)
    appearance: {
      theme: 'stripe',
      variables: {},
    }
  };

  return (
    <div>
      {Elements && stripePromise &&
        <Elements stripe={stripePromise} options={options} >
          <PaymentForm2 />
        </Elements>
      }
    </div>
  );
}